"use strict";

var _classCallCheck = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _possibleConstructorReturn = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _inherits = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactFastclickAlt = _interopRequireDefault(require("react-fastclick-alt"));
var _reactIntl = require("react-intl");
var _reactHelmet = require("react-helmet");
var _reactRouterDom = require("react-router-dom");
var _lodash = _interopRequireDefault(require("lodash"));
var _Page = _interopRequireDefault(require("./components/Page"));
var _LanguageSelectionModal = _interopRequireDefault(require("./components/LanguageSelectionModal"));
var _RouteLogger = _interopRequireDefault(require("./components/RouteLogger"));
var _ProductDetailsModal = _interopRequireDefault(require("./components/ProductDetailsModal"));
var _utils = require("./utils");
var _AnimatedRoute = _interopRequireDefault(require("./components/AnimatedRoute"));
var _Loader = _interopRequireDefault(require("./components/Loader"));
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}
function _interopRequireWildcard(e, t) {
  if ("function" == typeof WeakMap) var r = new WeakMap(),
    n = new WeakMap();
  return (_interopRequireWildcard = function _interopRequireWildcard(e, t) {
    if (!t && e && e.__esModule) return e;
    var o,
      i,
      f = {
        __proto__: null,
        default: e
      };
    if (null === e || "object" != typeof e && "function" != typeof e) return f;
    if (o = t ? n : r) {
      if (o.has(e)) return o.get(e);
      o.set(e, f);
    }
    for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
    return f;
  })(e, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var messages = {
  fr: {
    "email_form.first_name.label": "Prénom",
    "email_form.last_name.label": "Nom de famille",
    "email_form.age.label": "Age",
    "email_form.gender.label": "Genre",
    "email_form.gender.male": "Homme",
    "email_form.gender.female": "Femme",
    "email_form.gender.other": "Autre",
    "email_form.email.label": "E-mail",
    "coca_form.brugal_country.label": "1. Quel est le pays d’origine de la marque Brugal ?",
    "coca_form.brugal_country.italy.label": "Italie",
    "coca_form.brugal_country.spain.label": "Espagne",
    "coca_form.brugal_country.dominican_republic.label": "République Dominicaine",
    "coca_form.subsidiary_question.label": "2. Quel est le poids total de multipack de canettes Coca-Cola de 6x0,33L + 1 multipack de canettes Coca-Cola Zero Sugar de 6x0,33L + 1 multipack de canettes de Coca-Cola light de 6x0,33L en Kg, Gr et Mg* ? Pesé réalisé par notre huissier de justice, Maître Indekeu",
    "coca_form.last_name.label": "Nom*",
    "coca_form.first_name.label": "Prénom*",
    "coca_form.email.label": "Mail*",
    "coca_form.mandatory_fields.label": "*Champs obligatoires",
    "coca_form.gsm.label": "GSM*",
    "coca_form.yes.label": "oui",
    "coca_form.no.label": "non",
    "coca_form.partner_newsletter.label": "Oui, je désire être informé des prochaines actions et autres offres des marques de Coca-Cola European Partners",
    "coca_form.accepted_tos.label": "Oui, je reconnais avoir pris connaissance et j’accepte le règlement officiel du concours « nom concours » en ce compris le chapitre relatif au ‘Traitement des données à caractère personnel’.",
    "coca_form.private_data_acceptation_coca.label": "Oui, j’accepte que mes données à caractère personnel puissent être utilisées pour m’informer de tous les éventuels futurs concours, actions, promotions et offres de Coca-Cola",
    "coca_form.private_data_acceptation_partners.label": "Oui, j’accepte que mes données à caractère personnel puissent être utilisées pour m’informer de tous les éventuels futurs concours, actions, promotions, et offres de CLIENT / autre partenaire tiers."
  },
  en: {
    "email_form.first_name.label": "First name",
    "email_form.last_name.label": "Last name",
    "email_form.age.label": "Age",
    "email_form.gender.label": "Gender",
    "email_form.gender.male": "Male",
    "email_form.gender.female": "Female",
    "email_form.gender.other": "Other",
    "email_form.email.label": "Email"
  },
  nl: {
    "email_form.first_name.label": "Voornaam",
    "email_form.last_name.label": "Achternaam",
    "email_form.age.label": "Leeftijd",
    "email_form.gender.label": "Geslacht",
    "email_form.gender.male": "Man",
    "email_form.gender.female": "Vrouw",
    "email_form.gender.other": "Ander",
    "email_form.email.label": "E-mail",
    "coca_form.brugal_country.label": "1. Van welk land is Brugal rum afkomstig?",
    "coca_form.brugal_country.italy.label": "Italië",
    "coca_form.brugal_country.spain.label": "Spanje",
    "coca_form.brugal_country.dominican_republic.label": "Dominicaanse Republiek",
    "coca_form.subsidiary_question.label": "2. Onze gerechtsdeurswaarder Meester Indekeu weegt de volgende producten1 multipack blikken Coca-Cola de 6x0,33L + 1 multipack blikken Coca-Cola Zero Sugar de 6x0,33L + 1 multipack blikken Coca-Cola light de 6x0,33L. Wat is het totale gewicht van deze producten in Kg, Gr en Mg",
    "coca_form.last_name.label": "Achternaam*",
    "coca_form.first_name.label": "Voornaam*",
    "coca_form.email.label": "Mail*",
    "coca_form.gsm.label": "GSM*",
    "coca_form.mandatory_fields.label": "*Verplichte velden",
    "coca_form.yes.label": "ja",
    "coca_form.no.label": "nee",
    "coca_form.partner_newsletter.label": "Ja, ik wil graag op de hoogte gehouden worden van leuke acties en andere communicatie van Coca-Cola European Partners",
    "coca_form.accepted_tos.label": "Ja, ik heb het officiële reglement van de wedstrijd “naam wedstrijd” gelezen en aanvaard het, inclusief het clausule ‘Verwerking van Persoonsgegevens’.",
    "coca_form.private_data_acceptation_coca.label": "Ja, mijn contactgegevens mogen worden gebruikt om mij te informeren over alle mogelijke andere toekomstige wedstrijden, acties, promoties en aanbiedingen van Coca-Cola.",
    "coca_form.private_data_acceptation_partners.label": "Ja, mijn contactgegevens mogen worden gebruikt om mij te informeren over alle mogelijke andere toekomstige wedstrijden, acties, promoties en aanbiedingen van KLANT / andere derde partners."
  },
  de: {
    "email_form.first_name.label": "Vorname",
    "email_form.last_name.label": "Nachname",
    "email_form.age.label": "Alter",
    "email_form.gender.label": "Geschlecht",
    "email_form.gender.male": "Männlich",
    "email_form.gender.female": "Weiblich",
    "email_form.gender.other": "Andere",
    "email_form.email.label": "Email"
  }
};
var AsyncPageWrapper = function AsyncPageWrapper(props) {
  return /*#__PURE__*/_react.default.createElement(_react.Suspense, {
    fallback: /*#__PURE__*/_react.default.createElement(_Loader.default, null)
  }, /*#__PURE__*/_react.default.createElement(AsyncPage, props));
};
var AsyncPage = /*#__PURE__*/function (_react$default$Compon) {
  function AsyncPage() {
    var _this5;
    _classCallCheck(this, AsyncPage);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this5 = _callSuper(this, AsyncPage, [].concat(args));
    _defineProperty(_this5, "state", {});
    return _this5;
  }
  _inherits(AsyncPage, _react$default$Compon);
  return _createClass(AsyncPage, [{
    key: "loadPage",
    value: function loadPage() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _this$props, pageId, fetchPage, page;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _this$props = _this.props, pageId = _this$props.pageId, fetchPage = _this$props.fetchPage;
              _context.n = 1;
              return fetchPage(pageId);
            case 1:
              page = _context.v;
              _this.setState({
                page: page
              });
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return _this2.loadPage();
            case 1:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              if (!(!prevProps.pageId && _this3.props.pageId || prevProps.pageId !== _this3.props.pageId)) {
                _context3.n = 1;
                break;
              }
              _context3.n = 1;
              return _this3.loadPage();
            case 1:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        screenType = _this$props2.screenType,
        width = _this$props2.width,
        project = _this$props2.project,
        uriTransformer = _this$props2.uriTransformer,
        projectApp = _this$props2.projectApp,
        setCurrentPageAnimation = _this$props2.setCurrentPageAnimation;
      var page = this.state.page;
      if (!page) {
        // Per-project loading screen (set in the project settings); nothing is shown without one.
        if (!project.loading_image_uri || !screenType) return /*#__PURE__*/_react.default.createElement(_Loader.default, null);
        return /*#__PURE__*/_react.default.createElement("div", {
          style: {
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: width * screenType.y_dimension / screenType.x_dimension,
            background: "url(\"".concat(uriTransformer(project.loading_image_uri), "\") no-repeat center center / cover")
          }
        });
      }
      setTimeout(function () {
        setCurrentPageAnimation(page.animation_type);
      }, 400);
      return /*#__PURE__*/_react.default.createElement(_react.Suspense, {
        fallback: null
      }, /*#__PURE__*/_react.default.createElement(_Page.default, {
        currentSize: this.props.currentSize,
        setCurrentSize: this.props.setCurrentSize,
        displayLanguageModal: projectApp.displayLanguageModal.bind(projectApp),
        showProduct: projectApp.showProduct.bind(projectApp),
        uriTransformer: uriTransformer,
        page: page,
        width: width,
        visible: true,
        screenType: screenType,
        project: project,
        logEvent: projectApp.logEvent.bind(projectApp),
        changeLocale: projectApp.changeLocale.bind(projectApp)
      }));
    }
  }]);
}(_react.default.Component);
var ProjectApp = /*#__PURE__*/function (_react$default$PureCo) {
  function ProjectApp(props) {
    var _this6;
    _classCallCheck(this, ProjectApp);
    _this6 = _callSuper(this, ProjectApp, [props]);
    _defineProperty(_this6, "state", {
      languageModalVisible: false,
      currentSize: 1,
      currentPageAnimation: 'fade'
    });
    _defineProperty(_this6, "setCurrentSize", function (size) {
      _this6.setState({
        currentSize: size
      });
    });
    _defineProperty(_this6, "onProductDetailsModalClose", function () {
      return _this6.setState({
        productModalVisible: false
      });
    });
    _defineProperty(_this6, "onLanguageSelectionModalClose", function () {
      return _this6.setState({
        languageModalVisible: false
      });
    });
    _this6.updateWindowDimensions = _this6.updateWindowDimensions.bind(_this6);
    _this6.logEvent = _this6.logEvent.bind(_this6);
    return _this6;
  }
  _inherits(ProjectApp, _react$default$PureCo);
  return _createClass(ProjectApp, [{
    key: "displayLanguageModal",
    value: function displayLanguageModal() {
      this.setState({
        languageModalVisible: true
      });
    }
  }, {
    key: "showProduct",
    value: function showProduct(product, cell) {
      this.setState({
        productModalVisible: true,
        currentProduct: product,
        currentProductCell: cell
      });
    }
  }, {
    key: "changeLocale",
    value: function changeLocale(newLocale) {
      this.setState({
        locale: newLocale
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.updateWindowDimensions);
    }
  }, {
    key: "updateWindowDimensions",
    value: function updateWindowDimensions() {
      this.setState({
        viewWidth: window.innerWidth,
        viewHeight: window.innerHeight
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var _this4$props, project, _this4$props$fetchPag, fetchPage;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _this4.updateWindowDimensions();
              window.addEventListener('resize', _this4.updateWindowDimensions);
              _this4.setState({
                locale: _this4.props.project.primary_language_code
              });
              _this4.logEvent = _this4.logEvent.bind(_this4);
              _this4.changeLocale = _this4.changeLocale.bind(_this4);
              _this4.onLanguageSelectionModalClose = _this4.onLanguageSelectionModalClose.bind(_this4);
              _this4.onProductDetailsModalClose = _this4.onProductDetailsModalClose.bind(_this4);
              _this4$props = _this4.props, project = _this4$props.project, _this4$props$fetchPag = _this4$props.fetchPage, fetchPage = _this4$props$fetchPag === void 0 ? (/*#__PURE__*/function () {
                var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(pageId) {
                  return _regenerator().w(function (_context4) {
                    while (1) switch (_context4.n) {
                      case 0:
                        return _context4.a(2, _lodash.default.filter(project.pages, function (page) {
                          return page.id === pageId;
                        })[0]);
                    }
                  }, _callee4);
                }));
                return function (_x) {
                  return _ref.apply(this, arguments);
                };
              }()) : _this4$props$fetchPag;
            case 1:
              return _context5.a(2);
          }
        }, _callee5);
      }))();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              return _context6.a(2);
          }
        }, _callee6);
      }))();
    }
  }, {
    key: "logEvent",
    value: function logEvent(name, params) {
      if (!name) {
        return;
      }
      if (name === 'timeout') {
        this.setState({
          languageModalVisible: false,
          productModalVisible: false
        });
      }
      console.log("logging '".concat(name, "' event: ").concat(JSON.stringify(params)));
      if (!!window.AnalyticsWebInterface) {
        window.AnalyticsWebInterface.logEvent(name, JSON.stringify(params));
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this7 = this;
      var _this$state = this.state,
        locale = _this$state.locale,
        languageModalVisible = _this$state.languageModalVisible,
        viewWidth = _this$state.viewWidth,
        viewHeight = _this$state.viewHeight,
        productModalVisible = _this$state.productModalVisible,
        currentProduct = _this$state.currentProduct,
        currentProductCell = _this$state.currentProductCell;
      var _this$props3 = this.props,
        project = _this$props3.project,
        uriTransformer = _this$props3.uriTransformer,
        ratio = _this$props3.ratio,
        _this$props3$fetchPag = _this$props3.fetchPage,
        fetchPage = _this$props3$fetchPag === void 0 ? (/*#__PURE__*/function () {
          var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(pageId) {
            return _regenerator().w(function (_context7) {
              while (1) switch (_context7.n) {
                case 0:
                  return _context7.a(2, _lodash.default.filter(project.pages, function (page) {
                    return page.id === pageId;
                  })[0]);
              }
            }, _callee7);
          }));
          return function (_x2) {
            return _ref2.apply(this, arguments);
          };
        }()) : _this$props3$fetchPag;
      var _this$props4 = this.props,
        routeBaseName = _this$props4.routeBaseName,
        width = _this$props4.width;
      if (!project || !locale || !viewHeight || !viewWidth) {
        return null;
      }
      if (!width) width = viewWidth;
      var viewAspectRatio = ratio ? ratio : viewWidth / viewHeight;
      var screenType = project.screenTypes.reduce(function (prev, curr) {
        var currRatio = curr.x_dimension / curr.y_dimension;
        return Math.abs(currRatio - viewAspectRatio) < Math.abs(prev.ratio - viewAspectRatio) ? {
          screenType: curr,
          ratio: currRatio
        } : prev;
      }, {
        screenType: undefined,
        ratio: 0
      }).screenType;
      var height = width * screenType.y_dimension / screenType.x_dimension;
      var fontSize = (0, _utils.defaultFontSize)(screenType, width, height, project.default_font_ratio);
      project.languages.forEach(function (language) {
        (0, _reactIntl.addLocaleData)(require("react-intl/locale-data/".concat(language.code)));
      });
      var images = project.images || [];
      var videos = project.videos || [];
      var fonts = project.fonts;
      var fontsCss = fonts.map(function (font) {
        return "\n        @font-face {\n          font-family: '".concat(font.name, "';\n          src: url('").concat(uriTransformer(font.uri), "');\n        }");
      }).join('\n');
      return /*#__PURE__*/_react.default.createElement(_reactFastclickAlt.default, {
        threshold: 50
      }, /*#__PURE__*/_react.default.createElement(_LanguageSelectionModal.default, {
        logEvent: this.logEvent,
        project: project,
        onClose: this.onLanguageSelectionModalClose,
        changeLocale: this.changeLocale,
        languageModalVisible: languageModalVisible
      }), /*#__PURE__*/_react.default.createElement(_reactIntl.IntlProvider, {
        locale: locale,
        messages: messages[locale]
      }, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_ProductDetailsModal.default, {
        project: project,
        defaultLanguage: project.primary_language_code,
        onClose: this.onProductDetailsModalClose,
        productModalVisible: productModalVisible,
        uriTransformer: uriTransformer,
        cell: currentProductCell,
        product: currentProduct
      }), /*#__PURE__*/_react.default.createElement("div", {
        style: {
          position: 'absolute',
          width: width,
          minHeight: height
        }
      }, /*#__PURE__*/_react.default.createElement(_reactHelmet.Helmet, null, /*#__PURE__*/_react.default.createElement("meta", {
        name: "viewport",
        content: "width=".concat(width, ",initial-scale=1.0,user-scalable=no")
      }), /*#__PURE__*/_react.default.createElement("style", {
        type: "text/css"
      }, "\n                  ".concat(fontsCss, "\n                  html, body, div, span, applet, object, iframe,\n                  h1, h2, h3, h4, h5, h6, p, blockquote, pre,\n                  a, abbr, acronym, address, big, cite, code,\n                  del, dfn, em, img, ins, kbd, q, s, samp,\n                  small, strike, strong, sub, sup, tt, var,\n                  b, u, i, center,\n                  dl, dt, dd, ol, ul, li,\n                  fieldset, form, label, legend,\n                  table, caption, tbody, tfoot, thead, tr, th, td,\n                  article, aside, canvas, details, embed,\n                  figure, figcaption, footer, header, hgroup,\n                  menu, nav, output, ruby, section, summary,\n                  time, mark, audio, video {\n                      margin: 0;\n                      padding: 0;\n                      border: 0;\n                      font-size: 100%;\n                      font: inherit;\n                      vertical-align: baseline;\n                  }\n                  html {\n                    font-size: ").concat(fontSize, "px;\n                  }\n                  body {\n                      line-height: 1;\n                  }\n                  input:focus,\n                  select:focus,\n                  textarea:focus,\n                  button:focus {\n                      outline: none;\n                  }\n                  * {\n                    -webkit-tap-highlight-color: rgba(0,0,0,0);\n                  }\n                  ::-webkit-scrollbar {\n                    display: none;\n                  }\n                  * {\n                    user-drag: none;\n                    user-select: none;\n                    -moz-user-select: none;\n                    -webkit-user-drag: none;\n                    -webkit-user-select: none;\n                    -ms-user-select: none;\n                  }\n                  .react-grid-item {\n                    overflow: hidden;\n                  }\n                "))), /*#__PURE__*/_react.default.createElement(_reactRouterDom.BrowserRouter, {
        basename: routeBaseName
      }, /*#__PURE__*/_react.default.createElement(_RouteLogger.default, {
        logEvent: this.logEvent,
        location: location,
        idleTimeoutMs: (this.props.project.idle_timeout_seconds || 240) * 1000
      }, /*#__PURE__*/_react.default.createElement(_AnimatedRoute.default, {
        animationType: this.state.currentPageAnimation ? this.state.currentPageAnimation : "fade",
        renderSwitch: function renderSwitch(location) {
          return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Switch, {
            location: location
          }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
            exact: true,
            path: "/page/:pageId",
            render: function render(routeProps) {
              return /*#__PURE__*/_react.default.createElement(AsyncPageWrapper, {
                key: routeProps.location.key || routeProps.match.params.pageId,
                currentSize: _this7.state.currentSize,
                setCurrentSize: _this7.setCurrentSize,
                projectApp: _this7,
                fetchPage: fetchPage,
                pageId: routeProps.match.params.pageId,
                screenType: screenType,
                width: width,
                project: project,
                uriTransformer: uriTransformer,
                setCurrentPageAnimation: function setCurrentPageAnimation(page) {
                  return _this7.setState({
                    currentPageAnimation: page
                  });
                }
              });
            }
          }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
            render: function render() {
              return /*#__PURE__*/_react.default.createElement(AsyncPageWrapper, {
                key: project.main_page_id,
                currentSize: _this7.state.currentSize,
                setCurrentSize: _this7.setCurrentSize,
                projectApp: _this7,
                fetchPage: fetchPage,
                pageId: project.main_page_id,
                screenType: screenType,
                width: width,
                project: project,
                uriTransformer: uriTransformer,
                setCurrentPageAnimation: function setCurrentPageAnimation(page) {
                  return _this7.setState({
                    currentPageAnimation: page
                  });
                }
              });
            }
          }));
        }
      }))), project.loading_image_uri && /*#__PURE__*/_react.default.createElement("img", {
        src: uriTransformer(project.loading_image_uri),
        className: "tsku-nodisplay",
        alt: "loading-dl",
        "aria-hidden": true
      }), images.map(function (image, idx) {
        return /*#__PURE__*/_react.default.createElement("img", {
          key: idx,
          src: uriTransformer(image),
          className: "tsku-nodisplay",
          alt: "background-dl",
          "aria-hidden": true
        });
      })))));
    }
  }]);
}(_react.default.PureComponent);
_defineProperty(ProjectApp, "whyDidYouRender", true);
var ProjectWrapper = function ProjectWrapper(props) {
  return /*#__PURE__*/_react.default.createElement(_react.Suspense, {
    fallback: /*#__PURE__*/_react.default.createElement(_Loader.default, null)
  }, /*#__PURE__*/_react.default.createElement(ProjectApp, props));
};
var _default = exports.default = ProjectWrapper;